/* eslint-disable no-unused-vars */
import React from 'react';
import { PageWrapStyles } from './pagewrapstyles';

import Header from '../header';
import Map from '../map';
import Charts from '../charts';
import Footer from '../footer';

export default function PageWrap() {
  return (
    <PageWrapStyles>
      <Header />
      <Map />
      <Charts />
      <Footer />
    </PageWrapStyles>
  );
}
